import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CategoryIcon } from "@/components/CategoryIcon";

export function CategoryGrid({ categories, city = "etah", limit, basePath }) {
  const list = limit ? categories.slice(0, limit) : categories;
  const linkFor = (slug) => (basePath ? `${basePath}/${slug}` : `/${city}/${slug}`);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
      {list.map((c, i) => (
        <motion.div
          key={c.slug}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: Math.min(i * 0.03, 0.3) }}
        >
          <Link
            to={linkFor(c.slug)}
            className="group flex flex-col items-center text-center gap-2.5 p-4 md:p-5 rounded-2xl border border-border/60 bg-white hover:border-primary/40 hover:shadow-md transition-all"
            data-testid={`category-card-${c.slug}`}
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-accent flex items-center justify-center text-primary group-hover:scale-110 group-hover:bg-primary group-hover:text-white transition-all">
              <CategoryIcon icon={c.icon} className="w-6 h-6 md:w-7 md:h-7" />
            </span>
            <span className="font-semibold text-sm leading-tight">{c.name}</span>
            {typeof c.count === "number" && <span className="text-xs text-muted-foreground">{c.count} places</span>}
          </Link>
        </motion.div>
      ))}
    </div>
  );
}
